import Cookies from "js-cookie";
import { CiVideoOn } from "react-icons/ci";
import { FaMicrophone } from "react-icons/fa6";
import { HiOutlinePhotograph } from "react-icons/hi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoDocumentTextOutline } from "react-icons/io5";
import { getPreviewText } from "src/services/functions/wordsClip";
import { useContext } from "react";
import { MyContext } from "src/components/Context/MyContext";

const ReplyMessageBox = ({ replyMessage, setReplyMessage, showIcon = true }) => {
  const { userId } = useContext(MyContext);
  const authorName = Cookies.get("name");

  return (
    <div className="border rounded-[10px] border-[#979797] flex w-full bg-[#F2F2F2] h-[65px] shadow-sm shadow-[#00000040] overflow-hidden my-4 border-opacity-25 -mb-0 mt-3">
      <div className="bg-[#06CF9C] w-[8px]"></div>
      {replyMessage.type == "text" ? (
        <div className="flex-1 w-full p-2 flex justify-between h-full">
          <div>
            <h1 className="text-sm font-medium text-[#06CF9C] w-[215px]">{String(replyMessage.author) == userId ? (authorName === "ImWow Super Admin") ? replyMessage.authorName : "You" : replyMessage.authorName}</h1>
            <h1 className="text-sm font-normal text-[#92929D]">{getPreviewText(replyMessage?.content)}</h1>
          </div>
        </div>
      ) : replyMessage.type == "image" ? (
        <div className="relative rounded-[10px] flex w-full h-full overflow-hidden border-opacity-25">
          <div className="flex ml-2 flex-row  w-full">
            <div className="flex flex-col w-full">
              <h1 className="text-sm font-medium text-[#06CF9C] w-[115px]">{String(replyMessage.author) == userId ? (authorName === "ImWow Super Admin") ? replyMessage.authorName : "You" : replyMessage.authorName}</h1>
              <div className="flex items-center gap-x-1">
                <HiOutlinePhotograph />
                <p>Photo</p>
              </div>
            </div>
            <img src={replyMessage.content} className="w-[40px] h-full rounded-[10px] mr-8" />
          </div>
        </div>
      ) : replyMessage.type == "video" ? (
        <div className="relative rounded-[10px] flex w-full h-full overflow-hidden border-opacity-25">
          <div className="flex ml-2 flex-row  w-full">
            <div className="flex flex-col w-full">
              <h1 className="text-sm font-medium text-[#06CF9C] w-[115px]">{String(replyMessage.author) == userId ? (authorName === "ImWow Super Admin") ? replyMessage.authorName : "You" : replyMessage.authorName}</h1>
              <div className="flex items-center gap-x-1">
                <CiVideoOn />
                <p>Video</p>
              </div>
            </div>
            <img src={replyMessage.thumbnail} className="w-[45px] h-full object-cover rounded-[10px] mr-8" />
          </div>
        </div>
      ) : replyMessage.type == "file" ? (
        <div className="relative rounded-[10px] flex w-full h-full overflow-hidden border-opacity-25">
          <div className="flex ml-2 flex-row  w-full">
            <div className="flex flex-col w-full">
              <h1 className="text-sm font-medium text-[#06CF9C] w-[115px]">{String(replyMessage.author) == userId ? (authorName === "ImWow Super Admin") ? replyMessage.authorName : "You" : replyMessage.authorName}</h1>
              <div className="flex items-center gap-x-1">
                <IoDocumentTextOutline />
                <p>{replyMessage.content.split("/")[replyMessage.content.split("/").length - 1]}</p>
              </div>
            </div>
          </div>
        </div>
      ) : replyMessage?.type === "audio" ? (
        <div className="relative rounded-[10px] flex w-full h-full overflow-hidden border-opacity-25">
          <div className="flex ml-2 flex-row  w-full">
            <div className="flex flex-col w-full">
              <h1 className="text-sm font-medium text-[#06CF9C] w-[115px]">{String(replyMessage.author) == userId ? (authorName === "ImWow Super Admin") ? replyMessage.authorName : "You" : replyMessage.authorName}</h1>
              <div className="flex items-center gap-x-1">
                <FaMicrophone />
                <p> Voice Message {replyMessage.audioDuration}</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {showIcon && <AiOutlineCloseCircle onClick={() => setReplyMessage(null)} className="cursor-pointer mt-5" color="#979797" size={25} />}
    </div>
  );
};

export default ReplyMessageBox;
